import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/About.css';

function About() {
  return (
    <div className="about">
      <section className="page-header">
        <div className="header-particles">
          <div className="particle particle-1">⚡</div>
          <div className="particle particle-2">🤖</div>
          <div className="particle particle-3">☁️</div>
          <div className="particle particle-4">💡</div>
          <div className="particle particle-5">🔧</div>
        </div>
        <div className="container">
          <h1>About Us</h1>
          <p>Transforming businesses through intelligent automation and cloud innovation</p>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <div className="about-intro">
            <h2>Empowering SMEs with AI & Cloud Excellence</h2>
            <p>
              We are a specialized consulting firm dedicated to helping small and medium enterprises 
              harness the power of artificial intelligence and cloud technologies. Our mission is to 
              make enterprise-grade automation and infrastructure accessible to growing businesses 
              across the globe.
            </p>
          </div>

          <div className="mission-vision">
            <div className="mission-card">
              <h3>Our Mission</h3>
              <p>
                To democratize AI and cloud technologies for SMEs, enabling them to compete 
                with larger enterprises through intelligent automation, efficient processes, 
                and scalable infrastructure.
              </p>
            </div>

            <div className="vision-card">
              <h3>Our Vision</h3>
              <p>
                To become the trusted partner for SMEs worldwide in their digital transformation 
                journey, helping them achieve operational excellence through cutting-edge AI 
                and cloud solutions.
              </p>
            </div>
          </div>

          <div className="expertise-section">
            <h2>Our Expertise</h2>
            <div className="expertise-grid">
              <div className="expertise-item">
                <h4>AI & Machine Learning</h4>
                <p>
                  Advanced implementation of AI assistants, ChatGPT integrations, and 
                  LLM-based tools tailored to your business needs
                </p>
              </div>

              <div className="expertise-item">
                <h4>Cloud Architecture</h4>
                <p>
                  Expert design and implementation of AWS and Azure infrastructure 
                  with focus on scalability and cost optimization
                </p>
              </div>

              <div className="expertise-item">
                <h4>DevOps & Automation</h4>
                <p>
                  CI/CD pipeline setup, infrastructure as code, and process automation 
                  for streamlined operations
                </p>
              </div>

              <div className="expertise-item">
                <h4>Process Optimization</h4>
                <p>
                  RPA implementation and workflow automation across HR, finance, 
                  and customer support functions
                </p>
              </div>
            </div>
          </div>

          <div className="global-reach">
            <h2>Global Reach, Local Understanding</h2>
            <p>
              We proudly serve SMEs across four key markets, bringing deep understanding 
              of regional business needs and regulatory requirements:
            </p>
            <div className="regions-grid">
              <div className="region-item">
                <h4>🇺🇸 United States</h4>
                <p>Supporting American businesses with scalable automation solutions</p>
              </div>
              <div className="region-item">
                <h4>🇬🇧 United Kingdom</h4>
                <p>Helping UK SMEs navigate digital transformation</p>
              </div>
              <div className="region-item">
                <h4>🌍 Middle East</h4>
                <p>Empowering regional businesses with modern cloud infrastructure</p>
              </div>
              <div className="region-item">
                <h4>🇮🇳 India</h4>
                <p>Delivering cutting-edge AI solutions to Indian enterprises</p>
              </div>
            </div>
          </div>

          <div className="cta-box">
            <h2>Let's Work Together</h2>
            <p>Ready to transform your business with AI and cloud solutions?</p>
            <Link to="/contact" className="btn btn-primary">Get in Touch</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
